import React, { useEffect, useState, useRef, useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { io } from "socket.io-client";
import userSupportImg from "./img/support-icon.png";
import Swal from "sweetalert2";
import ImageModal from "./ImageModal"; // Import the modal component
import "bootstrap/dist/css/bootstrap.min.css";
import { DropdownButton, Dropdown } from "react-bootstrap";
// import "./Chat.css";
// import "./chatStyle.css";
import { Helmet } from "react-helmet";
import AuthContext from "../../context/AuthContext";
import { isEmpty } from "lodash";
import { IoArrowDownCircle, IoArrowUpCircle } from "react-icons/io5";
import useDynamicCSS from "../../components/useDynamicCss";
// // Connect to the socket.io server
// const socket = io(process.env.REACT_APP_CHAT_SOCKET, {
//   transports: ["websocket"], // Use only WebSocket transport
//   query: {
//     token: localStorage.getItem("token"),
//     userType: "front",
//   },
// });

const questionTree = {
  question:
    "Hello, how can we help you? Please select one of the options below to help us better understand your query:",
  options: {
    "একাউন্ট সমস্যা": {
      question: "Please specify your account issue:",
      options: {
        "লগইন সমস্যা": {
          question: "Are you unable to reset your password?",
          options: {
            "পাসওয়ার্ড ভুলে গেছি": {
              question: "Have you tried the 'Forgot Password' option?",
              options: {
                "হ্যাঁ, কিন্তু কাজ করছে না": {
                  question: "Please contact support for further assistance.",
                  options: {},
                },
                "না, এখন চেষ্টা করব": {
                  question:
                    "Please try resetting your password and let us know if you still face issues.",
                  options: {},
                },
              },
            },
            "OTP পাচ্ছি না": {
              question:
                "Are you receiving OTP on your registered mobile/email?",
              options: {
                "না, কিছুই পাচ্ছি না": {
                  question:
                    "Please check your spam folder or wait for some time.",
                  options: {},
                },
                "হ্যাঁ, কিন্তু OTP ইনপুটে কাজ করছে না": {
                  question:
                    "Try clearing your cache or using a different browser.",
                  options: {},
                },
              },
            },
          },
        },
        "একাউন্ট ব্লক": {
          question: "Has your account been suspended?",
          options: {
            "হ্যাঁ, আমি লগইন করতে পারছি না": {
              question:
                "Did you receive any email regarding account suspension?",
              options: {
                "হ্যাঁ, নিয়ম লঙ্ঘন সংক্রান্ত": {
                  question: "Please contact support for more details.",
                  options: {},
                },
                "না, কোনো ইমেল পাইনি": {
                  question: "Please check your spam folder or contact support.",
                  options: {},
                },
              },
            },
          },
        },
      },
    },
    "ডিপোজিট সমস্যা": {
      question: "What type of deposit issue are you facing?",
      options: {
        "লেনদেন সম্পন্ন হয়নি": {
          question: "Is your transaction pending?",
          options: {
            "হ্যাঁ, ২৪ ঘণ্টার বেশি হয়ে গেছে": {
              question: "Please provide your transaction ID to support.",
              options: {},
            },
            "না, কিছুক্ষণ আগেই করেছি": {
              question: "Wait for some time and check again.",
              options: {},
            },
          },
        },
        "ব্যালেন্স যোগ হয়নি": {
          question: "Is your deposit not reflecting?",
          options: {
            "হ্যাঁ, ১ ঘণ্টার বেশি সময় হয়ে গেছে": {
              question: "Please contact support with payment details.",
              options: {},
            },
            "না, ব্যালেন্স আপডেট হয়েছে": {
              question: "Great! Let us know if you need further help.",
              options: {},
            },
          },
        },
      },
    },
    "উইথড্র সমস্যা": {
      question: "What withdrawal issue are you facing?",
      options: {
        "উইথড্র প্রসেস হয়নি": {
          question: "Is your withdrawal stuck?",
          options: {
            "হ্যাঁ, ২৪ ঘণ্টার বেশি হয়ে গেছে": {
              question: "Please contact support with transaction details.",
              options: {},
            },
            "না, এটি প্রক্রিয়াধীন": {
              question: "Wait for some time and check your account.",
              options: {},
            },
          },
        },
        "ব্যালেন্স কম দেখাচ্ছে": {
          question: "Is the withdrawal amount incorrect?",
          options: {
            "হ্যাঁ, আমি সম্পূর্ণ ব্যালেন্স উইথড্র করতে পারছি না": {
              question: "Check if any bonus restrictions apply.",
              options: {},
            },
            "না, এটি একটি ছোট গ্লিচ": {
              question: "Try refreshing and checking again.",
              options: {},
            },
          },
        },
      },
    },
    "গেম সমস্যা": {
      question: "Which game issue are you experiencing?",
      options: {
        "গেম লোড হচ্ছে না": {
          question: "Is the game not loading?",
          options: {
            "হ্যাঁ, এটি একেবারে লোড হচ্ছে না": {
              question: "Try clearing your cache and reloading.",
              options: {},
            },
            "না, মাঝে মাঝে লোড হয়": {
              question: "Check your internet connection and try again.",
              options: {},
            },
          },
        },
        "গেম ক্র্যাশ করছে": {
          question: "Is the game crashing frequently?",
          options: {
            "হ্যাঁ, আমি খেলতে পারছি না": {
              question: "Try reinstalling the game or updating your device.",
              options: {},
            },
            "না, এটি শুধু মাঝে মাঝে হয়": {
              question: "Check if any updates are available.",
              options: {},
            },
          },
        },
      },
    },
    "প্রোমোশন অফার": {
      question: "Are you looking for active promotions?",
      options: {
        "হ্যাঁ, নতুন অফার জানতে চাই": {
          question: "Please visit the promotions page for latest offers.",
          options: {},
        },
        "না, আমি পুরোনো অফার সম্পর্কে জানতে চাই": {
          question: "Check your account history for previous promotions.",
          options: {},
        },
      },
    },
    "অন্যান্য সমস্যা": {
      question: "Can you describe your issue?",
      options: {
        "আমার ব্যক্তিগত প্রশ্ন আছে": {
          question: "Please contact support for personal inquiries.",
          options: {},
        },
        "আমি নতুন আপডেট সম্পর্কে জানতে চাই": {
          question: "Visit the updates section for the latest features.",
          options: {},
        },
      },
    },
  },
};

function ChatSupport() {
  let loader = useDynamicCSS(
    useMemo(() => ["/assets/Chat.css", "/assets/chatStyle.css"], [])
  );
  const { user, profileData } = useContext(AuthContext);
  const [checkRefresh, setCheckRefresh] = useState(true);
  const [socket, setSocket] = useState({});
  const [messages, setMessages] = useState([]);
  const conversationRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false); // Loading state
  const [sender, setSender] = useState("sent");
  const [senderId, setSenderId] = useState("");
  const [receiverId, setReceiverId] = useState("66e5df1a6ac8823254f3a1ce");
  const [chatId, setChatId] = useState(localStorage.getItem("visiterChatId"));
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal
  const [currentImageSrc, setCurrentImageSrc] = useState(""); // State for current image
  const [showOptions, setShowOptions] = useState(true); // Show question with options
  const [selectedOption, setSelectedOption] = useState(""); // Store selected option
  const [lastMsgId, setLastMsgId] = useState(null);
  const [seenTimestamps, setSeenTimestamps] = useState(new Set());
  const token = localStorage.getItem("token");
  // ----------  This code for audio recording from here ----------
  const [recording, setRecording] = useState(false);
  const [timer, setTimer] = useState(0);
  const [audioChunks, setAudioChunks] = useState([]);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioCancel, setAudioCancel] = useState(false);
  const isCanceledRef = useRef(false);
  const audioRef = useRef(null); // Update the path according to your structure

  const [currentQuestion, setCurrentQuestion] = useState(questionTree);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!isEmpty(user)) {
      setReceiverId("66e5df1a6ac8823254f3a1ce");
      setSenderId(user?.user?._id);
    }
  }, [user]);
  // Timer interval
  useEffect(() => {
    let interval = null;
    if (recording) {
      interval = setInterval(() => {
        setTimer((prev) => prev + 1);
      }, 1000); // Update timer every second
    } else if (!recording && timer !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [recording, timer]);

  // Function to stop the recording (save and send audio)
  const stopRecording = () => {
    console.log("........................ STOPING .....................");
    if (mediaRecorder) {
      isCanceledRef.current = false; // Reset cancel flag
      mediaRecorder.stop(); // Stop the recorder
      setRecording(false);
    }
  };

  // Function to cancel the recording (discard audio)
  const cancelRecording = () => {
    console.log("........................ CANCEL .....................");
    if (mediaRecorder) {
      isCanceledRef.current = true; // Set cancel flag
      mediaRecorder.stop(); // Stop the recorder
      setRecording(false);
    }
  };

  // Function to start recording
  const startRecording = async () => {
    try {
      const chunks = []; // Local variable to store audio chunks

      setTimer(0); // Reset timer when starting a new recording
      isCanceledRef.current = false; // Reset cancel state before recording

      // Access the user's microphone
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);

      // Log if the recorder is successfully created
      console.log("MediaRecorder initialized", recorder);

      // Event for data availability
      recorder.ondataavailable = (event) => {
        console.log("ondataavailable event", event.data.size); // Log data size
        if (event.data.size > 0) {
          chunks.push(event.data); // Add chunk to local variable
        }
      };

      // Event when recording stops (Triggered by stop or cancel)
      recorder.onstop = () => {
        console.log("Recording stopped");
        const audioBlob = new Blob(chunks, { type: "audio/wav" }); // Create Blob from local chunks
        console.log("Blob size after stop:", audioBlob.size);

        if (!isCanceledRef.current) {
          // Only send the audioBlob if the recording is not canceled
          if (audioBlob.size > 0) {
            sendAudioMessage(audioBlob);
          } else {
            console.error("Audio Blob is empty after recording");
          }
        } else {
          console.log("Recording canceled.");
        }

        // Stop all audio tracks to release the microphone
        stream.getTracks().forEach((track) => track.stop());
      };

      // Start recording and ensure data availability every 1 second
      recorder.start(1000); // Pass timeslice (1000ms = 1 second)

      setMediaRecorder(recorder);
      setRecording(true);
    } catch (error) {
      console.error("Error accessing microphone:", error);
      Swal.fire({
        icon: "error",
        title: "Microphone Access Denied",
        text: "Please allow microphone access in your browser settings.",
      });
    }
  };

  // Send audio message
  const sendAudioMessage = async (audioBlob) => {
    if (audioCancel) {
      return false;
    }
    const formData = new FormData();
    formData.append("TransactionFile", audioBlob, "recording.wav");
    formData.append("fileType", "audio");
    console.log("Sending audioBlob of size : ----- 1 ------ ", audioBlob);
    // Send the FormData to the API
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}v1/user/receipt-upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Include the Bearer token
          },
        }
      );

      console.log("File uploaded successfully:", response.data);

      // Create a new message object
      const newMessage = {
        message: "", // Leave the text empty for file uploads
        file: response.data.path, // Store the file path for rendering
        fileType: "AUDIO", // Get the file type
        senderId: senderId, // Add sender ID
        receiverId: receiverId, // Add receiver ID
        createdAt: new Date(),
      };

      // Emit the new message via socket
      socket.emit("sendMessage", newMessage);
      setMessages((prevMessages) => [...prevMessages, newMessage]);
      setLoading(false);
    } catch (error) {
      console.error("Error uploading file:", error);
      setLoading(false);
    }
  };
  // Format time as MM:SS
  const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  const getSocket = () => {
    const newSocket = io(
      `${process.env.REACT_APP_SOCKET}?token=${localStorage.getItem(
        "token"
      )}&userType=front`,
      {
        transports: ["websocket"],
      }
    );
    setSocket(newSocket);
    newSocket.emit("getChatHistory", chatId || "");
    newSocket.on("chatHistory", (messages) => {
      setMessages(messages);
    });

    newSocket.on("newMessage", function (data) {
      let chatIdOld = chatId;
      setChatId(data.chatId);
      localStorage.setItem("visiterChatId", data.chatId);
      if (audioRef.current) {
        audioRef.current.load();
        audioRef.current.play();
      }

      if (data.sender != senderId) {
        newSocket.emit("getChatHistory", chatId, function (data) {
          setLoading(false);
        });
        newSocket.emit("markAsRead", chatId, senderId);
      }

      if (chatIdOld != "null") {
        newSocket.emit("getChatHistory", chatId, function (data) {
          setLoading(false);
        });
      }

      setLoading(false);
    });

    newSocket.on("messagesRead", function (data) {
      setMessages((prevMessages) =>
        prevMessages.map((message) => ({ ...message, isRead: true }))
      );
    });

    newSocket.on("messageDeleted", function (data) {
      setMessages((prevMessages) => {
        return prevMessages.filter((message) => {
          return !data.messageIds.includes(message._id);
        });
      });
    });
    if (audioRef.current) {
      audioRef.current.load();
    }
    return () => newSocket.close();
  };
  useEffect(() => {
    if (checkRefresh && !isEmpty(user) && !isEmpty(profileData)) {
      getSocket();
    }
  }, [checkRefresh, user, profileData]);

  document.addEventListener("visibilitychange", function () {
    if (
      !document.hidden &&
      !checkRefresh &&
      !isEmpty(user) &&
      !isEmpty(profileData)
    ) {
      setCheckRefresh(true);
      if (!isEmpty(socket)) {
        socket.disconnect();
      }
    } else {
      setCheckRefresh(false);
    }
  });
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    setLoading(true);
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (file && validTypes.includes(file.type)) {
      // Create a FormData object
      const formData = new FormData();
      formData.append("TransactionFile", file);

      // Send the FormData to the API
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "v1/user/receipt-upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`, // Include the Bearer token
            },
          }
        )
        .then((response) => {
          console.log("File uploaded successfully:", response);
          // Handle success response here, e.g., update UI

          // Creating a new message object
          const newMessage = {
            message: "", // Leave the text empty for file uploads
            file: response.data.path, // Store the Base64 string for rendering the image
            fileType: "IMAGE", // Get the file extension
            senderId: senderId,
            receiverId: receiverId,
            createdAt: new Date(),
            //status :'sent'
          };

          // Update the state with the new message
          socket.emit("sendMessage", newMessage);
          setMessages((prevMessages) => [...prevMessages, newMessage]);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          setLoading(false);
          // Handle error response here
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid File!",
        text: "Please upload a valid image file (PNG, JPEG, JPG).",
      });
      setLoading(false);
    }
  };

  // Handle message sending
  const handleSend = (e) => {
    e.preventDefault();
    if (input.trim()) {
      const message = input;
      //senderId, receiverId, message, file, fileType
      setMessages([
        ...messages,
        {
          message: message,
          senderId: senderId,
          receiverId: receiverId,
          timestamp: new Date(),
          fileType: "text",
        },
      ]);

      // Emit the message to the server
      console.log("message : ", {
        message: message,
        senderId: senderId,
        receiverId: receiverId,
        fileType: "text",
      });
      socket.emit("sendMessage", {
        message: message,
        senderId: senderId,
        receiverId: receiverId,
        fileType: "text",
      });
      // Toggle the sender for the next message
      //setSender(sender === "sent" ? "received" : "sent");
      setInput("");
    }
  };

  useEffect(() => {
    // Scroll to the bottom of the conversation container
    if (isAtBottom && conversationRef.current) {
      // Scroll to the bottom only if the user is at the bottom
      conversationRef.current.scrollTop = conversationRef.current.scrollHeight;
    }
  }, [messages, isAtBottom]);

  const handleScroll = () => {
    if (conversationRef.current) {
      const { scrollTop, clientHeight, scrollHeight } = conversationRef.current;
      // Determine if user is at the bottom
      setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 1);
    }
  };

  // Function to format only time from the timestamp
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const openModal = (imageSrc) => {
    setCurrentImageSrc(imageSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Handle selecting an option
  const handleOptionClick = (option) => {
    const nextStep = currentQuestion.options[option];

    // Save selection in history
    setHistory([
      ...history,
      { question: currentQuestion.question, answer: option },
    ]);

    if (nextStep && Object.keys(nextStep.options).length > 0) {
      // Continue within the question tree
      setCurrentQuestion(nextStep);
    } else {
      // Question tree completed, now switch to chat socket logic
      setShowOptions(false); // Hide options

      setLoading(true); // Start loading
      if (socket && senderId && receiverId) {
        socket.emit("sendMessage", {
          message: option,
          senderId: senderId,
          receiverId: receiverId,
          fileType: "text",
          file: null,
        });

        socket.emit("getChatHistory", chatId, function (data) {
          console.log("data getHistoryData--- : ", JSON.stringify(data));
          setLoading(false);
        });

        socket.on("chatHistory", function (data) {
          console.log("data chatHistory : ", data);
          setMessages(data);
          setLoading(false);
        });

        socket.emit("markAsRead", chatId, senderId);
      }
    }
  };

  const handleDelete = (msgId) => {
    console.log("msgId : =====", msgId);
    // Emit delete event to the server
    socket.emit("deleteMessage", chatId, msgId);
    // Update local state to remove the message
    setMessages((prevMessages) =>
      prevMessages.filter((message) => message._id !== msgId)
    );
  };

  return (
    <div className="page">
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.1.2/css/material-design-iconic-font.min.css"
        />
      </Helmet>
      <div className="marvel-device nexus5">
        <div className="top-bar"></div>
        <div className="sleep"></div>
        <div className="volume"></div>
        <div className="camera"></div>
        <div className="screen">
          <div className="screen-container">
            <div className="chat">
              <div className="chat-container">
                <div className="user-bar">
                  <Link to="/chat">
                    <div className="back">
                      <i className="zmdi zmdi-arrow-left"></i>
                    </div>
                  </Link>
                  <div className="avatar">
                    <img src={userSupportImg} alt="Avatar" />
                  </div>
                  <div className="name">
                    <span>Support</span>
                    <span className="status">online</span>
                  </div>
                </div>
                <div className="conversation">
                  <div
                    className="conversation-container"
                    onScroll={handleScroll}
                    ref={conversationRef}
                  >
                    {history.length > 0 && (
                      <div className="">
                        {history.map((entry, index) => (
                          <div>
                            <div key={index} className="mb-2">
                              <p className={`message sent`}>{entry.question}</p>
                              {entry.answer && (
                                <div className=" message received ">
                                  {entry.answer}
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {loading ? (
                      <div className="loader-container">
                        <div className="spinner"></div>
                      </div>
                    ) : (
                      messages.map((msg, index) => (
                        <div
                          key={index}
                          className={`message ${
                            msg?.receiver === senderId ||
                            msg?.receiver?._id === senderId
                              ? "received"
                              : "sent"
                          }`}
                        >
                          <div className="action-btn">
                            <DropdownButton
                              id="dropdown-item-button"
                              title=""
                              variant="link"
                            >
                              {/* <Dropdown.Item as="button" onClick={() => handleEdit(messageId)}>Edit</Dropdown.Item> */}
                              <Dropdown.Item
                                as="button"
                                onClick={() => handleDelete(msg?._id)}
                              >
                                Delete
                              </Dropdown.Item>
                            </DropdownButton>
                          </div>
                          <div className="msg">
                            {msg.message}
                            {msg.file && (
                              <>
                                {msg.fileType === "IMAGE" && (
                                  <img
                                    src={
                                      process.env.REACT_APP_API_BASE_URL +
                                      msg.file
                                    }
                                    alt="Uploaded image"
                                    className="uploaded-image"
                                    onClick={() =>
                                      openModal(
                                        process.env.REACT_APP_API_BASE_URL +
                                          msg.file
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                                {msg.fileType === "AUDIO" && (
                                  <audio controls style={{ width: "260px" }}>
                                    <source
                                      src={
                                        process.env.REACT_APP_API_BASE_URL +
                                        msg.file
                                      }
                                      type="audio/wav"
                                    />
                                    Your browser does not support the audio
                                    element.
                                  </audio>
                                )}
                              </>
                            )}
                            <span className="metadata">
                              <span className="time">
                                {msg.timestamp
                                  ? formatTime(msg.timestamp)
                                  : formatTime(msg.createdAt)}
                              </span>
                            </span>
                            {msg?.isRead == undefined && (
                              <span className="status-icon">✔</span>
                            )}
                            {msg.isRead == false && (
                              <span className="status-icon">✔</span>
                            )}
                            {msg.isRead == true && (
                              <span className="status-icon">✔✔</span>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                  <form className="conversation-compose" onSubmit={handleSend}>
                    <div className="emoji">
                      <div
                        className="actions attachment more"
                        onClick={() =>
                          document.getElementById("file-upload").click()
                        }
                      >
                        <i className="zmdi zmdi-attachment-alt"></i>
                      </div>
                      <input
                        type="file"
                        id="file-upload"
                        style={{ display: "none" }}
                        onChange={handleFileUpload}
                        accept="image/png, image/jpeg, image/jpg"
                      />
                    </div>
                    <input
                      className="input-msg"
                      name="input"
                      placeholder="Type a message"
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      autoComplete="off"
                      autoFocus
                    />
                    {recording ? (
                      <div className="timer-audio">
                        <i class="zmdi zmdi-mic red-recording-dot"></i>
                        {formatTimer(timer)}{" "}
                        <button class="close-button" onClick={cancelRecording}>
                          ×
                        </button>
                      </div>
                    ) : (
                      <div
                        className="actions recording more"
                        onClick={recording ? stopRecording : startRecording}
                      >
                        <i
                          className={`zmdi ${
                            recording ? "zmdi-mic-off" : "zmdi-mic"
                          }`}
                        ></i>
                      </div>
                    )}

                    {/* <div className="photo"><i className="zmdi zmdi-camera"></i></div> */}
                    {recording ? (
                      <button
                        className="send"
                        type="submit"
                        onClick={recording ? stopRecording : startRecording}
                      >
                        <div className="circle">
                          <i className="zmdi zmdi-mail-send"></i>
                        </div>
                      </button>
                    ) : (
                      <button className="send" type="submit">
                        {/* <div className="circle">
                          <i className="zmdi zmdi-mail-send"></i>
                        </div> */}
                        <IoArrowUpCircle color="rgb(125, 0, 150)" size={35} />
                      </button>
                    )}
                  </form>

                  {/* Image Modal */}
                  <ImageModal
                    isOpen={isModalOpen}
                    imageSrc={currentImageSrc}
                    onClose={closeModal}
                  />
                  <video
                    ref={audioRef}
                    controls
                    oncontextmenu="return false;"
                    style={{ display: "none" }}
                  >
                    <source
                      src="https://ag.cricxo.bet/whatsapp_web.mp3"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChatSupport;

// showOptions ? (
//   // Display question with options
//   <div className="question-container">
//     <p>{currentQuestion.question}</p>
//     {Object.keys(currentQuestion.options).map(
//       (option, index) => (
//         <div
//           key={index}
//           onClick={() => handleOptionClick(option)}
//           className="option"
//         >
//           {option}
//         </div>
//       )
//     )}
//   </div>
// ) : // <div className="question-container">
//   <h2 className="text-lg font-semibold">{currentQuestion.question}</h2>
//   <div className="mt-4">
//     {Object.keys(currentQuestion.options).map((option, index) => (
//       <button
//         key={index}
//         onClick={() => handleOptionClick(option)}
//         className="option"
//       >
//         {option}
//       </button>
//     ))}
//   </div>
// </div>
// Chat view after selecting an option
